import { PageTitle } from "@/../_metronic/layout/core";
import { HospitalizationPermitsManagementPage } from "@/components/HospitalizationPermits/HospitalizationPermitsManagementPage";

export function HospitalizationPermitsManagement() {
	return (
		<>
			<PageTitle description="Listagem de AIH">Gerenciamento de AIH</PageTitle>
			<HospitalizationPermitsManagementPage />
		</>
	);
}
